<template>
  <!-- exhibition-product .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>My Cloud Booth</BreadcrumbItem>
          <BreadcrumbItem>Upload Products</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
        <p class="header-tool-text" style="font-weight:bold;color:#d13119;">Important: product information will be displayed on CMEF mini program and iCMEF website synchronously for visitors’searching</p> 
        <Input
          search
          placeholder="Please enter keywords"
          v-model="searchField"
          @on-search="searchPro()"
          v-if="String(showTabs) === '1'"
          style="width:230px;margin-top:20px;"
        /> 
      </div>
      <div v-show="String(showTabs) === '1'" class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibitionEn/index/product/addpro?num=' + proNum)">
          <span class="htb-add">+</span>
          <span>Add products</span>
        </div>
      </div>
      <!-- <div v-show="String(showTabs) === '3'" class="header-tool-box">
        <div class="htb-item" @click="downloadList()">
          <span class="htb-add">+</span>
          <span>名单下载</span>
        </div>
      </div> -->
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="Product" name="1">
          <exhibitionProductItem
            ref="exhibitionProductItem"
            v-if="String(showTabs) === '1'"
            :searchField="searchField"
            @numChange="numChange"
          />
        </TabPane>
        <TabPane label="Message" name="2">
          <exhibitionProductMes ref="exhibitionProductMes" v-if="String(showTabs) === '2'" />
        </TabPane>
        <!-- <TabPane label="试用申请" name="3">
          <exhibitionProductApply ref="exhibitionProductApply" v-if="String(showTabs) === '3'" />
        </TabPane> -->
      </Tabs>
    </div>

    <!-- 编辑产品 -->
    <!-- <product-edit
        :formData="current"
        :showed="editFlag"
        title="编辑产品"
        @form-submit="editProduct"
        @close="editFlag=false;"
        ref="productEdit"
    ></product-edit>-->
    <Contact />
  </div>
</template>

<script>
// import productEdit from "./../../components/product-edit.vue";
import exhibitionProductItem from "./../../subpages/exhibition-product-item/exhibition-product-item.vue";
import exhibitionProductMes from "./../../subpages/exhibition-product-mes/exhibition-product-mes.vue";
import exhibitionProductApply from "./../../subpages/exhibition-product-apply/exhibition-product-apply.vue";

import Contact from "@components/En/Contact/Contact";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "exhibition-business",
  data() {
    return {
      addBrandflag: false,
      showTabs: "1",
      searchField: "", // 搜索关键字
      proNum: 0
    };
  },
  components: {
    // productEdit,
    exhibitionProductItem,
    exhibitionProductMes,
    exhibitionProductApply,
    Contact
  },
  created() {
    this.changeTab();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      list: "productModule/list",
      pageInfo: "productModule/pageInfo",
      current: "productModule/current",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$route.query;
    }
  },
  methods: {
    ...mapMutations({
      refushPageInfo: "productModule/refushPageInfo",
      refushWheres: "productModule/refushWheres",
      refushCurrent: "productModule/refushCurrent"
    }),
    ...mapActions({
      getList: "productModule/getList",
      addProduct: "productModule/addProduct",
      add: "productModule/add",
      edit: "productModule/edit",
      getOne: "productModule/getOne",
      remove: "productModule/remove"
    }),
    numChange(e) {
      this.proNum = e;
    },
    searchPro() {
      this.$refs.exhibitionProductItem.init();
    },
    changeTab() {
      if (this.query && this.query.type && this.query.type === "all") {
        this.showTabs = "1";
        // this.flag = false;
      } else if (this.query && this.query.type && this.query.type === "mes") {
        this.showTabs = "2";
      } else if (this.query && this.query.type && this.query.type === "apply") {
        this.showTabs = "3";
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=all`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=mes`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=apply`);
      }
    },
    downloadList() {
      this.$refs.exhibitionProductApply.exportInfo();
    }
    // cancel(name) {
    //   this.$refs[name].handleReset();
    // },
    // async editShow(id) {
    //   this.editFlag = true;
    //   await this.getOne({ data: { id: id } });
    // },
    // exportInfo(name) {
    //   // 导出数据
    //   this.$refs[name].exportInfo();
    // },
    // setNume(num) {
    //   this.num = num;
    // },
    // async editProduct(form) {
    //   let req = {
    //     Id: form.id,
    //     SetValues: {
    //       Name: form.Name,
    //       Banner: form.Banner,
    //       StyleId: form.StyleId,
    //       Introduction: form.Introduction,
    //       IsApply: form.IsApply,
    //       ApplyMaxCount: form.ApplyMaxCount,
    //       ApplyStart: form.ApplyStart,
    //       ApplyEnd: form.ApplyEnd,
    //       Video: form.Video
    //     }
    //   };
    //   this.edit({
    //     data: req
    //   }).then(re => {
    //     this.editFlag = false;
    //     this.$Message.success("操作成功！");
    //     this.reload();
    //     this.$refs["productEdit"].handleReset();
    //   });
    // },
    // reload() {
    //   if (String(this.showTabs) === "1") {
    //     this.$refs["exhibitionProductItem"].init();
    //   } else if (String(this.showTabs) === "2") {
    //     this.$refs["exhibitionProductMes"].init();
    //   } else if (String(this.showTabs) === '3') {
    //     this.$refs["exhibitionProductApply"].init();
    //   }
    // },
  }
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
